import React, {FC, lazy, Suspense, useContext, useEffect, useState} from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Login from "./containers/login/Login";
import Loading from "./containers/Loading";
import AuthCallback from "./containers/authCallback/AuthCallback";
import {ISignedProps} from "./containers/SignedContainer";
import GoogleSignIn from "./containers/login/GoogleSignIn";
import Redirector from "./tools/Redirector";
import {GoogleOAuthProvider} from '@react-oauth/google';
import {AppConfig} from "./Config";
import {ThemeContext, ThemeProvider} from "./context/ThemeContext";
import {ConfigProvider, theme as antdTheme} from "antd";


const SignedContainer: FC<ISignedProps> = lazy(() => import("./containers/SignedContainer"));

const App = () => {

	const { theme } = useContext(ThemeContext);

	const [token, setToken] = useState<string | null>(localStorage.getItem('token'));

	useEffect(() => {
		const token = localStorage.getItem("token");
		const isInvitation = window.location.pathname.match(/\/invitation\/*/) !== null;
		if(isInvitation) {
			window.location.href = "/";
		}
		if (token === null) {
			if (
				window.location.pathname !== "/" &&
				window.location.pathname !== "/google_backup/callback" &&
				window.location.pathname !== "/google-signin" &&
				!isInvitation
			) {
				Redirector.storeUri(window.location.pathname);
				window.location.href = "/";
			}
		}
		const evtListener = () => {
			const newToken = localStorage.getItem('token');
			if (newToken !== null && token === null) {
				setToken(newToken);
			} else {
				window.location.href = "/";
			}
		};
		window.addEventListener("storage", evtListener);
		return () => window.removeEventListener("storage", evtListener);
	}, []);

	return (
		<ConfigProvider theme={{
			algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
			token: {
				colorBgBase: theme === 'dark' ? '#101010' : '#fff',
				colorTextBase: theme === 'dark' ? '#fff' : '#000',
				colorPrimary: theme === 'dark' ? '#64b5f6' : '#1677ff',
				colorLink: theme === 'dark' ? '#64b5f6' : '#1677ff',
				colorError: theme === 'dark' ? '#f14a46' : '#dd3633',
				colorSuccess: theme === 'dark' ? '#81c784' : '#28a745',
				colorWarning: theme === 'dark' ? '#f57c00' : '#faad14',
				borderRadius: 8,
			},
			cssVar: true,
		}}>
			<GoogleOAuthProvider clientId={AppConfig.getOauthClientId()}>
				<Suspense fallback={<Loading/>}>
					<BrowserRouter>
						<Routes>
							<Route path="/google-signin" element={<GoogleSignIn/>}/>
							<Route path="/google_backup/callback" element={<AuthCallback/>}/>
							<Route path="/" element={<Login/>}/>
							{
								token === null
									? null
									:
									<Route
										path="/*"
										key={"s_2"}
										element={<SignedContainer authToken={token}/>}
									/>
							}
						</Routes>
					</BrowserRouter>
				</Suspense>
			</GoogleOAuthProvider>
		</ConfigProvider>
	);
};

export default () => (
	<ThemeProvider>
		<App />
	</ThemeProvider>
);
